import { arquivoService } from "./arquivo";
import { diretorioService } from "./diretorio";
import { EArquivoSituacao, EDiretorioSituacao } from "../Enum/Enum";

/**
 * Exclui recursivamente um diretório e todo o seu conteúdo (arquivos e subdiretórios).
 * 
 * @param {number} IDDiretorio - ID do diretório a ser excluído
 * @param {number} IDProcesso - ID do processo (usado na busca de subdiretórios)
 * @returns {Promise<boolean>} - true se tudo for excluído corretamente, false caso contrário
 */
export const excluirDiretorioRecursivamente = async (IDDiretorio, IDProcesso) => {
    try {
        // 1. Inativa todos os arquivos da pasta
        const arquivosResp = await arquivoService.listarArquivosPorPasta(IDDiretorio);
        const arquivos = arquivosResp?.arquivos ?? [];

        for (const arquivo of arquivos) {
            const res = await arquivoService.atualizarSituacaoArquivo(arquivo.IDArquivo, EArquivoSituacao.INATIVO);
            if (res?.status !== 204) {
                console.error("Erro ao inativar arquivo:", arquivo.IDArquivo);
                return false;
            }
        }

        // 2. Busca e exclui recursivamente todos os subdiretórios
        const subDirsResp = await diretorioService.listarDiretoriosPorIDPai(IDDiretorio, IDProcesso);
        const subDiretorios = subDirsResp?.diretorios ?? [];

        for (const sub of subDiretorios) {
            const sucesso = await excluirDiretorioRecursivamente(sub.IDDiretorio, IDProcesso);
            if (!sucesso) return false;
        }

        // 3. Inativa o diretório atual
        const res = await diretorioService.atualizarSituacaoDiretorio(IDDiretorio, EDiretorioSituacao.INATIVO);
        if (res?.status !== 204) {
            console.error("Erro ao inativar diretório:", IDDiretorio);
            return false;
        }

        return true;

    } catch (error) {
        console.error("Erro durante exclusão recursiva:", error);
        return false;
    }
};
